module.exports = __webpack_public_path__ + "static/media/atom.4b6f5d22.svg";